import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { activeBtn, btn, ButtonList } from "./styles";

function ButtonsList({ mode, btnClick }) {
  const companyCode = localStorage.getItem("companyCode");
  const history = useHistory();
  const handleActivity = () => {
    history.push("/inventory/admin/report/customer-report");
  };

  return (
    <Box>
      <Typography sx={{ padding: "5px" }}>Report Type</Typography>
      <Box sx={ButtonList} className="ml-22">
        {companyCode != 4416 && (
          <>
            <Button
              size="small"
              variant="contained"
              sx={mode == "sales" ? activeBtn : btn}
              onClick={() => btnClick("sales")}
            >
              Sales
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "combinedSales" ? activeBtn : btn}
              onClick={() => btnClick("combinedSales")}
            >
              Combined Sales
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "salesReturn" ? activeBtn : btn}
              onClick={() => btnClick("salesReturn")}
            >
              Sales Return
            </Button>
          </>
        )}
        <Button
          size="small"
          variant="contained"
          sx={mode == "expense" ? activeBtn : btn}
          onClick={() => btnClick("expense")}
        >
          Expense
        </Button>
        {companyCode != 4416 && (
          <>
            <Button
              size="small"
              variant="contained"
              sx={mode == "purchase" ? activeBtn : btn}
              onClick={() => btnClick("purchase")}
            >
              Purchase
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "purchaseReturn" ? activeBtn : btn}
              onClick={() => btnClick("purchaseReturn")}
            >
              Purchase Return
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "stock" ? activeBtn : btn}
              onClick={() => btnClick("stock")}
            >
              Stock
            </Button>
          </>
        )}

        <Button
          size="small"
          variant="contained"
          sx={btn}
          onClick={handleActivity}
        >
          Ledger Activity
        </Button>
        {companyCode != 4416 && (
          <>
            <Button
              size="small"
              variant="contained"
              sx={mode == "customerSale" ? activeBtn : btn}
              onClick={() => btnClick("customerSale")}
            >
              Customer Sale
            </Button>

            <Button
              size="small"
              variant="contained"
              sx={mode == "supplierPurchase" ? activeBtn : btn}
              onClick={() => btnClick("supplierPurchase")}
            >
              Supplier Purchase
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "vehicleExpense" ? activeBtn : btn}
              onClick={() => btnClick("vehicleExpense")}
            >
              Vehicle Expense
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "gatePass" ? activeBtn : btn}
              onClick={() => btnClick("gatePass")}
            >
              Gate Pass
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "profitLoss" ? activeBtn : btn}
              onClick={() => btnClick("profitLoss")}
            >
              Profit Loss
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "balanceSheet" ? activeBtn : btn}
              onClick={() => btnClick("balanceSheet")}
            >
              Balance Sheet
            </Button>

            <Button
              size="small"
              variant="contained"
              sx={mode == "paymentReport" ? activeBtn : btn}
              onClick={() => btnClick("paymentReport")}
            >
              Payment
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "employeeReport" ? activeBtn : btn}
              onClick={() => btnClick("employeeReport")}
            >
              Sales By Employee
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={mode == "banksReport" ? activeBtn : btn}
              onClick={() => btnClick("banksReport")}
            >
              Banks
            </Button>
            {/* <Button
              size="small"
              variant="contained"
              sx={mode == "credit" ? activeBtn : btn}
              onClick={() => btnClick("credit")}
            >
              Credit
            </Button> */}
          </>
        )}
      </Box>
    </Box>
  );
}

export default ButtonsList;
